// Translation: Account > Profile > Specialties (Russian)
export default Object.freeze({
	form: {
		fields: {
			img_labeling: '',
			ml_engineering: '',
			scientist: '',
			text_labeling:	'',
			translation: ''
		}
	},
	title: ''
})
